import React from 'react';
import classNames from 'classnames';
import Image from 'next/image';

import SectionTitle from '@/ui/SectionTitle/SectionTitle';
import { ArrowRight, Tick } from '@/icons/index';
import { ActiveLink, TextBlock } from '@/ui/index';

import styles from './Steps.module.scss';

const Step = ({ step, number }) => {
  const renderLinkOrText = () => {
    if (step?.button_text) {
      return (
        <ActiveLink href={step.button_slug || '/'}>
          <a
            title={step.button_text}
            aria-label={step.button_text}
            className={styles['step-item__activate']}
            itemScope
            itemType='https://schema.org/Action'
          >
            <span className={styles['step-item__activate-text']}>
              {step.button_text}
            </span>
            <div className={styles['step-item__activate-iconContainer']}>
              {step?.button_type === 'tick' ? (
                <Tick className={styles['step-item__activate-icon']} />
              ) : (
                <ArrowRight className={styles['step-item__activate-icon']} />
              )}
            </div>
          </a>
        </ActiveLink>
      );
    }
    return (
      <TextBlock
        className={classNames(styles['step-item__content'], 'text--medium')}
        itemScope
        itemType='https://schema.org/Text'
      >
        <span className={styles['step-item__content-text']}>
          {step.description}
        </span>
      </TextBlock>
    );
  };

  return (
    <div
      className={styles['step-item']}
      itemScope
      itemType='https://schema.org/HowToStep'
    >
      <div className={styles['step-item__number']}>
        <span className={styles['step-item__number-count']}>{number}</span>
      </div>
      <div className={styles['step-item__img-wrapper']}>
        <Image
          src={step?.image}
          alt={step.button_text}
          title={step.button_text}
          loading='lazy'
          layout='fill'
        />
      </div>
      {renderLinkOrText()}
    </div>
  );
};

const Steps = ({ data, type }) => {
  const getTypeClass = (() => {
    if (type === 'dark') return styles['steps--dark'];
    if (type === 'fill') return styles['steps--fill'];
    return '';
  })();

  const renderSteps = (step, index) => {
    return <Step step={step} number={index + 1} key={index} />;
  };

  return (
    <section
      className={classNames([styles.steps, 'section wrapper', getTypeClass])}
      itemScope
      itemType='https://schema.org/HowTo'
    >
      <div className={styles.steps__head}>
        {data?.title && (
          <SectionTitle
            className={styles.steps__title}
            titleModify='title--large'
            icon={data?.icon}
          >
            {data.title}
          </SectionTitle>
        )}
        {data?.text && <span className={styles.steps__text}>{data.text}</span>}
      </div>
      {data?.sections && (
        <div className={styles.steps__inner}>
          {data.sections?.map(renderSteps)}
        </div>
      )}
    </section>
  );
};

export default Steps;
